import styled from 'styled-components';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StoreCard } from '../StoreCard';
import { useStateContext } from '../../context';
import { IAvailableStore } from '../../types';

const ShowMore = styled.div``;

interface IProps {
    availableStores: IAvailableStore[];
    className?: string;
}

const BaseStoreList = ({ availableStores, className }: IProps) => {
    const { searchLocation, useCurrentLocation, storesSortedByDistance } =
        useStateContext();
    const listRef = useRef<HTMLDivElement>(null);
    const [showAllStores, toggleShowAllStores] = useState(false);
    const initialListLimit = 30;
    const { t } = useTranslation();

    useEffect(() => {
        if (!listRef.current) return;

        listRef.current.scrollTop = 0;
    }, [searchLocation]);

    if (!storesSortedByDistance) return null;

    const displayedStores = showAllStores
        ? storesSortedByDistance
        : storesSortedByDistance.slice(0, initialListLimit);

    return (
        <div className={className} ref={listRef}>
            {displayedStores.map((store, index) => (
                <StoreCard
                    key={store.id}
                    hideDistance={!useCurrentLocation}
                    store={store}
                    searchPosition={index + 1}
                />
            ))}
            {availableStores.length > initialListLimit && (
                <ShowMore onClick={() => toggleShowAllStores(!showAllStores)}>
                    {showAllStores ? t('showLess') : t('showAll')}
                </ShowMore>
            )}
        </div>
    );
};

export const StoreList = styled(BaseStoreList)`
    flex: 1;
    padding-bottom: 30px;

    ${StoreCard} {
        margin-top: 1rem;
    }

    ${ShowMore} {
        text-decoration: underline;
        margin-left: 1rem;
        margin-top: 1rem;
        cursor: pointer;
    }
`;
